import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import de from './locales/de.json';
import zh from './locales/zh.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import legalEn from './locales/legal-en.json';
import legalFr from './locales/legal-fr.json';
import legalEs from './locales/legal-es.json';
import legalPt from './locales/legal-pt.json';
import legalDe from './locales/legal-de.json';
import legalZh from './locales/legal-zh.json';
import legalJa from './locales/legal-ja.json';
import legalKo from './locales/legal-ko.json';

// Merge translations
const mergedEn = { ...en, ...legalEn };
const mergedFr = { ...fr, ...legalFr };
const mergedEs = { ...es, ...legalEs };
const mergedPt = { ...pt, ...legalPt };
const mergedDe = { ...de, ...legalDe };
const mergedZh = { ...zh, ...legalZh };
const mergedJa = { ...ja, ...legalJa };
const mergedKo = { ...ko, ...legalKo };

const resources = {
  en: { translation: mergedEn },
  fr: { translation: mergedFr },
  es: { translation: mergedEs },
  pt: { translation: mergedPt },
  de: { translation: mergedDe },
  zh: { translation: mergedZh },
  ja: { translation: mergedJa },
  ko: { translation: mergedKo }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'fr', 'es', 'pt', 'de', 'zh', 'ja', 'ko'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage']
    }
  });

export default i18n;
